const palette = {
	getDesignTokens: mode => ({
		mode,
		background: {
			eveCustom: {
				secondary: '#FAFAFA',
				...(mode === 'dark' && {
					secondary: '#141414',
				}),
			},
		},
		components: {
			input: {
				outlined: {
					eveCustom: {
						disabledBG: 'rgba(0, 0, 0, 0.06)',
						...(mode === 'dark' && {
							disabledBG: 'rgba(27, 27, 27, 0.06)',
						}),
						readOnlyBG: 'rgba(0, 0, 0, 0.06)',
						...(mode === 'dark' && {
							readOnlyBG: 'rgba(27, 27, 27, 0.06)',
						}),
					},
				},
			},
		},
		text: {
			disabled: 'rgba(0, 0, 0, 0.55)',
			...(mode === 'dark' && {
				disabled: 'rgba(255, 255, 255, 0.55)',
			}),
		},
	}),
};

export default palette;
